import { ListHeader } from 'components/molecules/ListHeader';
import { FC } from 'react';

export const NotificationListHeader: FC = () => (
  <ListHeader
    columns={[
      'タイトル',
      '本文',
      '種別',
      '状態',
      '表示開始日時',
      '表示終了日時',
    ]}
    templateColumns="3fr 4fr 1fr 1fr 2fr 2fr"
  />
);
